/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import PropTypes from 'prop-types';

import { Box, Button } from '@material-ui/core';

import LocaleMessage from '~/components/LocaleMessage';

import compareVersions from '~/util/CompareVersions';

import { InfoCard } from '../../../RobotPage/RobotData/styles';

const h100 = { height: '100%' };

export default function ActionsCard({
    width,
    options,
    robot,
    robotType,
    allowAction,
    renderLoading,
    runFunction,
    header,
    permission,
}) {
    const status = robot.status || {};
    const { status: robot_status } = status;
    const { showWhenDisconnected } = options;
    const app_version =
        status && status.application && status.application.version
            ? status.application.version
            : '0.0.0';
    const { actions } = options;

    let status_actions =
        actions && robot_status && actions[robot_status]
            ? actions[robot_status]
            : null;

    if (
        !status_actions &&
        showWhenDisconnected &&
        robot_status === 'disconnected' &&
        actions
    ) {
        status_actions =
            actions.disconnected || actions.connected || actions.alert || null;
    }

    function renderActionButton(action) {
        const c = action.backgroundColor;
        const blacklist = action.blacklist || {};
        const perm_blacklist = blacklist.permission || [];

        const allow_permission = perm_blacklist.indexOf(permission) === -1;
        let allow_version = true;
        if (action.min_versions && action.min_versions[robotType]) {
            const min_version = action.min_versions[robotType] || [0, 0, 0];
            allow_version = compareVersions(min_version, app_version);
        }

        const disabled = !allowAction || !allow_permission;
        const style = disabled
            ? {
                  backgroundColor: '#999',
              }
            : {
                  ...(c !== 'primary' && {
                      backgroundColor: c,
                  }),
                  color: '#fff',
              };

        return allow_version ? (
            <Button
                key={action.key}
                className="mb-3"
                variant="contained"
                fullWidth
                onClick={() => runFunction(action.onClick)}
                style={style}
                disabled={disabled}
                color={c === 'primary' ? 'primary' : undefined}
            >
                {action.label ? <LocaleMessage msg={action.label} /> : null}
            </Button>
        ) : null;
    }

    const showDisconnectedCard =
        showWhenDisconnected && robot_status === 'disconnected';

    return status_actions &&
        (robot_status !== 'disconnected' || showDisconnectedCard) ? (
        <div className={`${width} mb-3`} style={h100}>
            <Box style={h100}>
                <InfoCard>
                    <div className="desc-full">
                        {allowAction ? (
                            <>
                                {header || (
                                    <span className="mb-3">
                                        <LocaleMessage msg="rc3.robot.data.card.actions" />
                                    </span>
                                )}
                                {status_actions.map(a => {
                                    return renderActionButton(a);
                                })}
                            </>
                        ) : (
                            <div className="mb-3 pt-0 desc-full">
                                {renderLoading()}
                            </div>
                        )}
                    </div>
                </InfoCard>
            </Box>
        </div>
    ) : null;
}

ActionsCard.propTypes = {
    width: PropTypes.string,
    options: PropTypes.object,
    robot: PropTypes.object,
    robotType: PropTypes.string,
    renderLoading: PropTypes.func.isRequired,
    runFunction: PropTypes.func.isRequired,
    allowAction: PropTypes.bool,
    header: PropTypes.element,
    permission: PropTypes.string,
};

ActionsCard.defaultProps = {
    width: 'col-12',
    options: { key: 'total', style: 'bar', size: 'col-12' },
    robot: {},
    allowAction: false,
    header: null,
    permission: 'viewer',
    robotType: '',
};
